import type { ReactNode } from 'react';
import type { RemixiconComponentType } from '@remixicon/react';
import { waadooIcons } from './icons/waadooIcons';

export type StatusChipStatus =
  | 'healthy'
  | 'progressing'
  | 'degraded'
  | 'failed'
  | 'unknown';

/** The icon of each status — also the promotion chain's state marks. */
export const STATUS_ICONS: Record<StatusChipStatus, RemixiconComponentType> = {
  healthy: waadooIcons.statusHealthy,
  progressing: waadooIcons.statusProgressing,
  degraded: waadooIcons.statusDegraded,
  failed: waadooIcons.statusFailed,
  unknown: waadooIcons.statusUnknown,
};

export interface StatusChipProps {
  status: StatusChipStatus;
  /** The status in words; the icon and the colour only repeat it. */
  label: ReactNode;
}

/**
 * A status as an icon and its words, both in the status colour — never the
 * colour alone (WCAG 1.4.1). Coloured by `.waadoo-status-chip--<status>` in
 * styles.css on BUI's foreground status tokens; the progressing icon turns,
 * unless the reader asked for reduced motion.
 */
export function StatusChip(props: StatusChipProps) {
  const Icon = STATUS_ICONS[props.status];
  return (
    <span className={`waadoo-status-chip waadoo-status-chip--${props.status}`}>
      <Icon
        className="waadoo-status-chip__icon"
        aria-hidden
        focusable="false"
      />
      {props.label}
    </span>
  );
}
